module dg.clients {

    export class ApplicationInfoService {
        public static webAppClientId: string = angular.element(document.querySelector("meta[name='digmo_webAppClientId']")).attr("content");


        //public adalConfig;
        initialized: boolean;

        public constructor(private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private clientInfoService: dg.clients.ClientInfoService,
            private usersService: dg.modules.users.UsersService) {

            this.initialized = false;
        }

        public ensureInitialized() {
            let defer = this.$q.defer();

            if (this.initialized) {
                defer.resolve();
            }
            else {

                //HACK: because server fails after login
                let waitTime = 1000;
                this.$timeout(() => {
                    this.clientInfoService.getClientInfo().then((clientInfo) => {

                        this.usersService.getCurrentUser().then(user => {

                            this.initialized = true;
                            //$rootScope.currentUser = user;

                            defer.resolve();
                        }, defer.reject);
                    }, defer.reject);
                }, waitTime);
                
            }

            return defer.promise;
        }

        public getCurrentUser(){
            return this.usersService.getLoadedCurrentUser();
        }
    }

    //export class ApplicationInfoServiceProvider {
      
    //    private applicationInfo: ApplicationInfoService;

    //    public constructor() {
    //        this.$get.$inject = [
    //        ];
    //        this.initializeClientInfo();
    //    }

    //    private initializeClientInfo() {
    //        this.applicationInfo = {
                
    //            adalConfig: {}
    //        };
    //    }

    //    public getApplicationInfo() {
    //        return this.applicationInfo;
    //    }

    //    public setAdalConfig(adalConfig) {
    //        this.applicationInfo.adalConfig = adalConfig;
    //    }

    //    public $get(): ApplicationInfoService {
    //        return this.applicationInfo;
    //    }
    //}

    angular.module('dg.clients')
        .service('applicationInfoService', ApplicationInfoService);
}